var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_100_601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "#75A49A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 30.5,
    stroke: "black",
    strokeWidth: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2184,
    y: 10.3052,
    width: 43.0252,
    height: 43.3898,
    fill: "url(#pattern0_100_601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_100_601",
    x: 0,
    y: 0,
    width: 68,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_100_601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_100_601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_100_601",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_100_601",
    transform: "matrix(0.01 0 0 0.00991597 0 0.00420172)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_100_601",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramcircle);
export default __webpack_public_path__ + "static/media/telegramcircle.617bb628a885a83b00f44ab6ec7c3cdc.svg";
export { ForwardRef as ReactComponent };